import React from 'react';

import { DollarInputField } from '../../Fields';
import { EditableViewProps } from '../types';

interface RepaymentsAmountTeamViewProps extends EditableViewProps {
  disableFailMessage?: boolean;
  isZeroValid?: boolean;
  name: string;
  validationFailMessage?: string;
  label?: string;
}

export const RepaymentsAmountTeamView = (props: RepaymentsAmountTeamViewProps) => {
  const { name, isOptional, label, isDisabled, isZeroValid, disableFailMessage, validationFailMessage } = props;
  return (
    <DollarInputField
      label={label}
      name={name}
      isOptional={isOptional}
      isDisabled={isDisabled}
      disableFailMessage={disableFailMessage}
      validationFailMessage={validationFailMessage}
      isFullWidth
      isZeroValid={isZeroValid}
    />
  );
};
